import {
  createRouter,
  createWebHashHistory,
  RouteRecordRaw,
} from 'vue-router';

import CampaignSignUp from '@/views/signup/CampaignSignUp.vue';
import ChooseProject from '@/views/signup/ChooseProject/ChooseProject.vue';
import YourData from '@/views/signup/YourData/YourData.vue';
import Appointment from '@/views/signup/Appointment/Appointment.vue';
import Success from '@/views/signup/Success/Success.vue';
import AppointmentContact from '@/views/signup/AppointmentContact/AppointmentContact.vue';
import { trackRouter } from 'vue-gtag-next';

import store from '@/store/index';

function employeeIdPreCheck() {
  let result: boolean | { name: string, replace: boolean } = false;

  if (store.state.employeeID) {
    result = true;
  } else {
    window.history.replaceState({}, '', '#/signup/yourdata');
    result = {
      name: 'YourData',
      replace: true,
    };
  }

  return result;
}

function isAppointmentRegisteredPreCheck() {
  let result: boolean | { name: string, replace: boolean } = false;

  if (store.state.appointmentRegistered) {
    result = true;
  } else {
    window.history.replaceState({}, '', '#/signup/appointment');
    result = {
      name: 'Appointment',
      replace: true,
    };
  }

  return result;
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/signup/chooseproject',
  },
  {
    path: '/signup',
    redirect: '/signup/chooseproject',
  },
  {
    path: '/signup',
    name: 'CampaignSignUp',
    component: CampaignSignUp,
    children: [
      {
        path: 'chooseproject',
        name: 'ChooseProject',
        component: ChooseProject,
      },
      {
        path: 'yourdata',
        name: 'YourData',
        component: YourData,
      },
      {
        path: 'appointment',
        name: 'Appointment',
        component: Appointment,
        beforeEnter: [employeeIdPreCheck],
      },
      {
        path: 'success',
        name: 'Success',
        component: Success,
        beforeEnter: [employeeIdPreCheck, isAppointmentRegisteredPreCheck],
      },
      {
        path: 'appointment-contact',
        name: 'AppointmentContact',
        component: AppointmentContact,
        beforeEnter: [employeeIdPreCheck],
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

trackRouter(router);
/** Tracks the router for Google Analytics */
export default router;
